(function () {
  if (window.navigator.userAgent.indexOf('gonative') !== -1) {
    const passlist = [
      'account', // account-related routes (login, register, manage)
      'challenge', // Shopify's integrated google recaptcha
      'tools/recurring', // recharge-related routes
      'apps',
    ];
    
    const loc = window.location;
    const bypass = passlist.some(function (str) {
      return loc.pathname.indexOf(str) > -1;
    });
    
    function matchesAbandonedCart() {
      const param = loc.pathname.split('cart/')[1];
      return param && param.match(/^[0-9]/);
    }
    
    if (!bypass && !matchesAbandonedCart()) {
      loc.host = 'app.sportsfuel.co.nz';
    }
  }
})();
